import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';

export const ColorCarousel: StyleRule<{ visible: boolean }> = ({
    visible,
}) => ({
    display: visible ? 'block' : 'none',
    overflowX: 'auto',
    overflowY: 'hidden',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    scrollbarWidth: 0,
    maxWidth: '100vw',
});

export const ColorCarouselInner: StyleRule = () => ({
    display: 'flex',
    flexWrap: 'nowrap',
    padding: pxArrayToRem([4, 18, 10, 18]),
});
